import React from "react";


export function AboutPage(){

    return(
        <div className="AboutPage">
            <h2>About Page</h2>
        </div>
    )
}